import { render } from "./ChooseRooms.vue?vue&type=template&id=326ddd86&scoped=true"
import script from "./ChooseRooms.vue?vue&type=script&lang=js"
export * from "./ChooseRooms.vue?vue&type=script&lang=js"

import "./ChooseRooms.vue?vue&type=style&index=0&id=326ddd86&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326ddd86"]])

export default __exports__